import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface compareImageIdI {
  workId: string
  imageId: string
}

const initialState: compareImageIdI = {
  workId: '',
  imageId: ''
}

export const setCompareImageInfoISlice = createSlice({
  name: 'setCompareImageInfo',
  initialState,
  reducers: {
    setCompareWorkId: (state, action: PayloadAction<string>) => {
      state.workId = action.payload
    },
    setCompareImageId: (state, action: PayloadAction<string>) => {
      state.imageId = action.payload
    }
  }
})
export const { setCompareWorkId, setCompareImageId } = setCompareImageInfoISlice.actions
export default setCompareImageInfoISlice.reducer
